module.exports = __webpack_public_path__ + "img/teach6.5e928f17.jpg";